export const PLAN_BASIC_SUBSCRIPTION = {
  M17: "M17",
  M18: "M18",
  M19: "M19",
  B6: "B6",
};
